import { Observable } from 'rxjs'
import { InsightsDashboardLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageUtils } from '../../Common/Utils/LanguageUtils'
import { $waitForElements } from '../Utilities/WaitForElements'
import { enableUserTour } from '../Adapter/UserTourAdapter'

export const newInsightsTour = (): void => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(InsightsDashboardLanguage.NAME)

    enableUserTour([
        {
            elements: (): Observable<HTMLElement[]>[] => [$waitForElements('.idtb-right')],
            content: language.get(InsightsDashboardLanguage.InsightsDashboard_Tour_Step_1)
        },
        {
            elements: (): Observable<HTMLElement[]>[] => [$waitForElements('.idii-quick-info')],
            content: LanguageUtils.formatLanguageEntry(
                language.get(InsightsDashboardLanguage.InsightsDashboard_Tour_Step_2)
            )
        },
        {
            elements: (): Observable<HTMLElement[]>[] => [$waitForElements('.id-summary-info')],
            content: LanguageUtils.formatLanguageEntry(
                language.get(InsightsDashboardLanguage.InsightsDashboard_Tour_Step_3)
            )
        },
        {
            elements: (): Observable<HTMLElement[]>[] => [$waitForElements('.idii-highlight-info')],
            content: language.get(InsightsDashboardLanguage.InsightsDashboard_Tour_Step_4)
        },
        {
            elements: (): Observable<HTMLElement[]>[] => [$waitForElements('#sidebar-button-reporting')],
            content: language.get(InsightsDashboardLanguage.InsightsDashboard_Tour_Step_5),
            interceptClick: true,
            disableGutter: true,
            disableNext: true
        }
    ])
}
